import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "relative flex min-h-screen flex-col overflow-hidden py-6 sm:py-12" }
const _hoisted_2 = {
  key: 0,
  class: "min-h-28"
}
const _hoisted_3 = { class: "max-w-screen-lg mx-auto py-4 px-4 lg:px-0" }
const _hoisted_4 = { class: "flex gap-3 justify-center flex-wrap" }

import { onMounted } from 'vue';
import { useBlog } from '@/composables/useBlog';
import BlogItem from '@/components/BlogItem.vue';
import Footer from '@/components/Footer.vue';
import NavBar from '@/components/NavBar.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'BlogListingView',
  setup(__props) {

const { blogs, getAllBlogs, isLoading } = useBlog();

onMounted(() => {
  getAllBlogs();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createVNode(NavBar),
      _cache[0] || (_cache[0] = _createStaticVNode("<section class=\"relative py-10 bg-white\"></section><section class=\"relative pt-20 pb-20 bg-[#151515]\"><div class=\"w-full max-w-lg md:max-w-2xl lg:max-w-4xl px-5 lg:px-11 mx-auto max-md:px-4 flex flex-col items-center justify-center\"><h1 class=\"text-white text-center font-semibold text-4xl min-[500px]:text-5xl leading-tight mb-2 font-josefin\"> Our Latest Blog </h1><h3 class=\"text-[#7F7F7F] text-center w-[80%]\"> TALAB is your ultimate guide to luxury living in the capital. From the best food &amp; drink, fashion and beauty to exclusive events. </h3></div></section>", 2)),
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_Transition, { name: "slide-right" }, {
          default: _withCtx(() => [
            (!_unref(isLoading))
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(blogs), (post) => {
                        return (_openBlock(), _createBlock(BlogItem, {
                          key: post.id,
                          post: post,
                          class: "lg:w-[30%] w-full"
                        }, null, 8, ["post"]))
                      }), 128))
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ])
    ]),
    _createVNode(Footer)
  ], 64))
}
}

})